@let serviceRequest = $serviceRequest | async;
<!---->
@let serviceRequestsFetchedAt = $serviceRequestsFetchedAt | async;
<!---->

<div class="container">
  <mat-card>
    <mat-card-content>
      @if (serviceRequest) {
      <div
        class="pointer"
        (click)="navToCustomerDetails(serviceRequest.customerId)"
      >
        <display-input
          title="Customer"
          [value]="serviceRequest.customer?.name"
        />
      </div>
      <display-input
        title="Order Number"
        [value]="serviceRequest.orderNumber"
      />
      <display-input title="OTP" [value]="serviceRequest.otp" />
      <display-input
        title="Package Weight (kg)"
        [value]="serviceRequest.weight.toString()"
      />
      <display-input
        title="Package Volume (cm³)"
        [value]="serviceRequest.volume.toString()"
      />
      <display-input
        title="Package Count"
        [value]="serviceRequest.packageCount.toString()"
      />
      <display-input
        title="Created At"
        [value]="(serviceRequest.createdAt | date:'dd/MM/yyyy HH:mm') || '-'"
      />
      <display-input
        title="Updated At"
        [value]="(serviceRequest.updatedAt | date:'dd/MM/yyyy HH:mm') || '-'"
      />
      <display-input
        title="Status"
        [value]="utils.getServiceRequestStatus(serviceRequest.status)"
      />

      <div class="row">
        <div class="col-6">
          <div class="header">Pickup Address</div>
          <display-input
            title="Street Number"
            [value]="serviceRequest.pickupAddress.streetNumber"
          />
          <display-input
            title="Street"
            [value]="serviceRequest.pickupAddress.street"
          />
          <display-input
            title="Suburb"
            [value]="serviceRequest.pickupAddress.suburb"
          />
          <display-input
            title="Province"
            [value]="serviceRequest.pickupAddress.province"
          />
          <display-input
            title="Postal Code"
            [value]="serviceRequest.pickupAddress.postalCode"
          />
          <display-input
            title="Country"
            [value]="serviceRequest.pickupAddress.country"
          />
          <display-input
            title="Longitude"
            [value]="serviceRequest.pickupAddress.longitude.toString()"
          />
          <display-input
            title="Latitude"
            [value]="serviceRequest.pickupAddress.latitude.toString()"
          />
        </div>
        <div class="col-6">
          <div class="header">Delivery Address</div>
          <display-input
            title="Street Number"
            [value]="serviceRequest.deliveryAddress.streetNumber"
          />
          <display-input
            title="Street"
            [value]="serviceRequest.deliveryAddress.street"
          />
          <display-input
            title="Suburb"
            [value]="serviceRequest.deliveryAddress.suburb"
          />
          <display-input
            title="Province"
            [value]="serviceRequest.deliveryAddress.province"
          />
          <display-input
            title="Postal Code"
            [value]="serviceRequest.deliveryAddress.postalCode"
          />
          <display-input
            title="Country"
            [value]="serviceRequest.deliveryAddress.country"
          />
          <display-input
            title="Longitude"
            [value]="serviceRequest.deliveryAddress.longitude.toString()"
          />
          <display-input
            title="Latitude"
            [value]="serviceRequest.deliveryAddress.latitude.toString()"
          />
        </div>
      </div>
      } @if (!serviceRequest && !serviceRequestsFetchedAt) {
      <div class="d-flex justify-content-center align-items-center">
        <mat-progress-spinner
          class="me-2"
          mode="indeterminate"
          color="primary"
          diameter="30"
        />
      </div>
      }
    </mat-card-content>
  </mat-card>
</div>
